var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import MuiModal from '@mui/material/Modal';
import { CloseIcon } from './Icons';
import { IconButton } from './IconButton';
import { CardTitle } from './CardTitle';
import { Stack } from '@mui/material';
import { getIsMobile } from '../services/utilisateur';
var styleHeader = {
    width: '100%',
};
var styleBody = {
    display: 'block',
    bgcolor: 'background.paper',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    height: '100%',
};
export var Modal = function (_a) {
    var title = _a.title, _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.iconTitle, iconTitle = _c === void 0 ? null : _c, _d = _a.renderButton, renderButton = _d === void 0 ? null : _d, _e = _a.forceOpen, forceOpen = _e === void 0 ? false : _e, _f = _a.handleCloseModal, handleCloseModal = _f === void 0 ? null : _f, _g = _a.color, color = _g === void 0 ? 'primary' : _g, _h = _a.hiddenCloseModal, hiddenCloseModal = _h === void 0 ? false : _h, _j = _a.smallModal, smallModal = _j === void 0 ? false : _j;
    var isMobile = getIsMobile();
    var _k = React.useState(false), open = _k[0], setOpen = _k[1];
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () {
        setOpen(false);
        if (handleCloseModal) {
            handleCloseModal();
        }
    };
    return (_jsxs("div", { children: [renderButton && renderButton(handleOpen), _jsx(MuiModal, __assign({ open: open || forceOpen, onClose: handleClose, sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } }, { children: _jsxs(Stack, __assign({ sx: {
                        minWidth: !isMobile ? '30%' : null,
                        maxWidth: smallModal ? '30%' : '80%',
                        maxHeight: '80%',
                        borderRadius: 'md',
                        p: 3,
                        boxShadow: 'lg',
                    } }, { children: [_jsx(Box, __assign({ sx: styleHeader }, { children: _jsx(CardTitle, { color: color, title: title, startIcon: iconTitle, renderButtons: function () {
                                    return !hiddenCloseModal && (_jsx(IconButton, __assign({ tooltip: "Fermer", color: "white", onClick: handleClose }, { children: _jsx(CloseIcon, {}) })));
                                } }) })), _jsx(Box, __assign({ sx: styleBody }, { children: _jsx(Box, __assign({ className: "p-small" }, { children: children })) }))] })) }))] }));
};
//# sourceMappingURL=Modal.js.map